import { API_BASE_URL } from '../constants/api';

class BackendLogsService {
  createStream(after = 0) {
    const query = after ? `?after=${encodeURIComponent(after)}` : '';
    return new EventSource(`${API_BASE_URL}/backend-logs/stream${query}`, { withCredentials: true });
  }

  async getErrors(hours = 24) {
    const response = await fetch(`${API_BASE_URL}/backend-logs/errors?hours=${hours}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch backend errors');
    }
    return data;
  }
}

export default new BackendLogsService();
